import {createStyles, makeStyles, Theme} from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grid: {
      color: 'transparent',
      backgroundColor: theme.palette['main-bg-indigo'],
      height: '100%',
      [theme.breakpoints.down('md')]: {
        height: '50%',
      },
    },
    loginFormGrid: {
      height: '100%',
    },
  })
);
